var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderComponent'),_c('Transition',{attrs:{"mode":"out-in","name":"page"},on:{"after-enter":_vm.onPageEnter}},[_c('RouterView',{key:_vm.$route.fullPath})],1),_c('FooterComponent'),(_vm.$store.state.showMobileMenu)?_c('MobileMenu'):_vm._e(),_c('ModalsComponent'),_c('CookiesComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }